// extracted by mini-css-extract-plugin
export default {"PPLiveCasino":"PPLiveCasino_PPLiveCasino__3oTKs","Logo":"PPLiveCasino_Logo__vpyYL","LcLoader":"PPLiveCasino_LcLoader__BGpzs","Error":"PPLiveCasino_Error__WHtNE"};